import { useTranslation } from "react-i18next";
import { ANY, GENDER_TEXT } from "helpers/constants";
import multiMode from "./filterBaseMulti";
import singleMode from "./filterBaseSingle";

const rawItems = [
	{
		key: "women",
		value: 0,
		meta: {
			url: "women",
			// Url z poprzedniej w wersji DZ dla zachowania zgodności linków
			urlValue: "0",
			value: 1,
		},
	},
	{
		key: "men",
		value: 1,
		meta: {
			url: "men",
			// Url z poprzedniej w wersji DZ dla zachowania zgodności linków
			urlValue: "1",
			value: 2,
		},
	},
	{
		key: "couples",
		value: 2,
		meta: {
			url: "couples",
			// Url z poprzedniej w wersji DZ dla zachowania zgodności linków
			urlValue: "2",
			value: 4,
		},
	},
	{
		key: "transsexuals",
		value: 3,
		meta: {
			url: "transsexuals",
			// Url z poprzedniej w wersji DZ dla zachowania zgodności linków
			urlValue: "3",
			value: 8,
		},
	},
];

export { rawItems };

export const isValid = (value) => {
	if (value === "") {
		return true;
	}
	const validValuesArray = rawItems.map((item) => item.meta.url);
	const incomingValuesArray = value ? value.split(/[,/-]/) : [];

	const incomingValuesArrayRemovedDuplicates = [
		...new Set(incomingValuesArray),
	];

	if (
		incomingValuesArray.length !==
		incomingValuesArrayRemovedDuplicates.length
	) {
		return false;
	}

	for (let i = 0; i < incomingValuesArray.length; i++) {
		if (!validValuesArray.includes(incomingValuesArray[i])) {
			return false;
		}
	}

	return true;
};

export const isValidCouple = (valueSex, valueSexCouple) => {
	if (valueSex !== "couple") {
		return true;
	}

	if (valueSex === "couple" && valueSexCouple === "") {
		return true;
	}
	const validValuesArray = rawItems.map((item) => item.meta.urlValue);

	if (valueSex === "couple" && validValuesArray.includes(valueSexCouple)) {
		return true;
	}

	return false;
};

export const compute = (multiple) =>
	multiple
		? {
				valueToApiParam: (values) => {
					const current = values
						? rawItems
								.filter((item) => values.includes(item.value))
								.map((item) => item.meta.value)
						: [];
					return current.length
						? current.reduce((left, right) => left + right, 0)
						: null;
				},
				valueToUrl: (values) => {
					const current = values
						? rawItems.filter((item) => values.includes(item.value))
						: [];
					return current.length
						? current.map((item) => item.meta.url).join("-")
						: ""; //"woman-man-couple-transsexual";
				},
				urlToApiParam: (value) => {
					if (value === ANY || !value) return null;
					const sexArray = value.split(/[,\/-]/).map((item) => {
						if (Number.isInteger(Number(item))) {
							return (
								rawItems.find(
									({ meta: { urlValue } }) =>
										urlValue === item
								)?.meta?.value ?? 0
							);
						}
						return (
							rawItems.find(({ meta: { url } }) => url === item)
								?.meta?.value ?? 0
						);
					});
					const finalValue = sexArray.reduce(
						(acc, sex) => acc + sex,
						0
					);
					return finalValue;
				},
				urlToValue: (value) => {
					if (value === ANY || !value) return [];
					return value.split(/[,\/-]/).map((item) => {
						if (Number.isInteger(Number(item))) {
							return (
								rawItems.find(
									({ meta: { urlValue } }) =>
										urlValue === item
								)?.meta?.value ?? 0
							);
						}
						return (
							rawItems.find(({ meta: { url } }) => url === item)
								?.meta?.value ?? 0
						);
					});
				},
				urlToCheckedValue: (value) => {
					if (value === ANY || !value) return [];
					return value.split(/[,\/-]/).map((item) => {
						if (Number.isInteger(Number(item))) {
							return (
								rawItems.find(
									({ meta: { urlValue } }) =>
										urlValue === item
								)?.value ?? 0
							);
						}
						return (
							rawItems.find(({ meta: { url } }) => url === item)
								?.value ?? 0
						);
					});
				},
		  }
		: {
				valueToApiParam: (value) => {
					const current = rawItems.find(
						(item) => item.value === value
					);
					return current ? current.meta.value : null;
				},
				urlToApiParam: (value) => {
					const current = rawItems.find(
						(item) => item.meta.url === value
					);
					return current ? current.meta.value : null;
				},
				urlToValue: (value) => {
					if (!value) return null;
					return (
						rawItems.find(
							({ meta: { urlValue } }) => urlValue === value
						)?.value ?? null
					);
				},
				valueToUrl: (value) => {
					const current = rawItems.find(
						(item) => item.value === value
					);
					return current ? current.meta.url : "any";
				},
				valueToUrlNumberValue: (value) => {
					const current = rawItems.find(
						(item) => item.value === value
					);
					return current ? current.meta.urlValue : "";
				},
		  };

const useFilterSexSeo = ({ initial, multiple = false, couple = false }) => {
	const { t } = useTranslation(["common"]);

	let items = rawItems.map((item) => ({
		...item,
		content: t(`common:sexOptions.${item.key}`),
		text: t(`common:sexOptions.${item.key}`),
	}));

	if (couple) items = items.filter(({ key }) => key !== GENDER_TEXT.COUPLE);

	return {
		items,
		compute: compute(multiple),
		isMultiple: multiple,
		isValid,
		isValidCouple,
		...(multiple
			? multiMode({ items, initial, compute })
			: singleMode({ items, initial, compute })),
	};
};

export default useFilterSexSeo;
